<template>
    <div class="representative-patent">
        <div class="representative-patent-collapse" :style="collapseStyle" @click="expand">
            <span>{{ $t(`customFields.familyTip.${representative}Title`) }}</span>
            <PtIcon :icon="isExpand ? 'SolidArrowUp' : 'SolidArrowRight'" :style="iconStyle" />
        </div>
        <div v-if="isExpand" class="representative-patent-content" :style="{ 'border-radius': isExpand ? '0 0 4px 4px': '4px'}">
            {{ $t(`customFields.familyTip.${representative}Tip`) }}
        </div>
    </div>
</template>
<script>
import { Icon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/ArrowRight.svg';
import '@patsnap-ui/icon/assets/solid/ArrowUp.svg';
export default {
    name: 'RepresentativePatent',
    components: {
        PtIcon: Icon,
    },
    props: {
        isRepresentative: {
            type: Boolean,
        },
    },
    data() {
        return { 
            isExpand: true,
        };
    },
    computed: {
        representative() {
            return this.isRepresentative ? 'representative' : 'member';
        },
        collapseStyle() {
            return {
                'cursor': 'pointer',
                'border-radius': this.isExpand ? '4px 4px 0 0': '4px',
                'background-color': this.isRepresentative ?  '#45A321' : '#E3F1DE',
                'color': this.isRepresentative ? '#fff' : '#020A1A',
            };
        },
        iconStyle() {
            return {
                'cursor': 'pointer',
                'font-size': '20px',
                'color': this.isRepresentative ? '#fff' : '#020A1A',
            };
        },
    },
    methods: {
        expand() {
            this.isExpand = !this.isExpand;
        },
    },
};
</script>
<style lang="scss">

.representative-patent {
   margin-top: 8px;
   width:100%;
   &-collapse {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 4px; 
        padding: 4px 8px;
        font-size: 12px;
   }
   &-content {
        background: $bg-normal;
        border-radius: 4px; 
        padding: 8px;
        color: $text-hint;
        font-size: 12px;
   }
}

</style>
